import { Component, OnInit } from '@angular/core';
import { IMyDrpOptions } from 'mydaterangepicker';

// Servicios
import { RutasService } from '../../services/rutas.service';
import { CuadreService } from '../../services/cuadre.service';

// Helpers
import { Helper } from '../../helpers/helper';
import { ActivatedRoute, Params, Router  } from '@angular/router';
import { LowerCasePipe } from '@angular/common';
import { EmpleadosServicio } from '../../services/empleado.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const ID_PAGINA = 14;

@Component({
  selector: 'app-cuadres-faltante',
  templateUrl: './cuadres-faltante.component.html',
  styleUrls: ['./cuadres-faltante.component.css']
})
export class CuadresFaltanteComponent implements OnInit {
  rutas = [];
  cuadres = [];
  diferencia = 0;
  busqueda = '';
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  page = 1;
  limit = 50;
  offset = 0;
  size = 0;
  loaded = false;
  loading = false;
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  multiSelectPrestamos: any;
  columnsSort = [];
  private columnsServer = [];
  lowerCasePipe = new LowerCasePipe();
  constructor(
    private rutaService: RutasService,
    private cuadreService: CuadreService,
    private helper: Helper,
    private route: ActivatedRoute,
    private router: Router,
    private empleadoService: EmpleadosServicio
    ) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.initRutas();
    /*if ( localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }*/

    this.initColumns();
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }
  }

  ngOnInit() {
    this.initConfigMultiSelect();
    this.verificarQueryString();
  }

  private initRutas() {
    this.rutaService.cargarTodasLasRutas()
    .subscribe(rutas => {
      for (const ruta of rutas.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: String(ruta.nombre)
        });
      }
    });
  }

  private initConfigMultiSelect() {
    this.multiSelectPrestamos = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  private initCuadres() {
    this.loading = true;
    let fecha_desde = '';
    let fecha_hasta = '';
    if (this.fecha_desde) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
    this.cuadreService.obtenerCuadresConDiferencia(
      this.limit,
      this.offset,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.busqueda,
      fecha_desde,
      fecha_hasta,
      JSON.stringify(this.columnsServer)).subscribe((res: any) => {
      this.cuadres = res.cuadres;
      this.size = res.total_items;
      this.diferencia = res.total_diferencia;
      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    });
  }

  filtrarCuadre() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['rutas'] = this.rutasSeleccionadas.map(data => data.id).join();
    queryParams['limite'] = this.limit;
    queryParams['busqueda'] = this.busqueda;

    if (
      this.fecha_desde !== undefined &&
      this.fecha_desde !== null &&
      this.fecha_desde.year !== null
    ) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (
      this.fecha_hasta !== undefined &&
      this.fecha_hasta !== null &&
      this.fecha_hasta.year !== null
    ) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    this.router.navigate(['./lista/cuadres-con-faltante'], { queryParams: queryParams });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }
        if (params.busqueda) {
          this.busqueda = params.busqueda;
        }

        if (params.hasOwnProperty('rutas')) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
        }
        if (params.fecha_inicia || params.fecha_termina) {

          if (params.fecha_inicia) {
            const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
            const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
            const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

            if ( !isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit ) ) {
              this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
            }
          }

          if (params.fecha_termina) {
            const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
            const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
            const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

            if ( !isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd ) ) {
              this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
            }
          }
        }
        if (params.hasOwnProperty('limite') && !isNaN(params.limite)) {
          this.limit = params.limite;
        }

        if (params.hasOwnProperty('page') && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }
        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }
        this.initCuadres();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.offset = this.limit * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/cuadres-con-faltante'], { queryParams: queryParams });
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./lista/cuadres-con-faltante'], { queryParams: queryParams });
  }

  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'Zona',
        column: 'ruta',
        order: ''
      },
      {
        label: 'Entregado a',
        column: 'a.entregadoA',
        order: ''
      },
      {
        label: 'Fecha',
        column: 'a.fecha_apertura',
        order: ''
      },
      {
        label: 'Diferencia',
        column: 'cd.diferencia',
        order: ''
      },
      {
        label: 'Detalle',
        column: 'cd.detalle_cierre',
        order: ''
      }
    ];
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/cuadres-faltante/cuadres-faltante.component.ts